import React, { useEffect, useState } from 'react'

import getYears, { GetYearsOptions, Year } from 'api/vehicles/getYears'
import { FormikDropdown } from 'components/FormikFields'
import { FormikDropdownChild } from 'components/FormikFields/FormikDropdown/FormikDropdown'
import { FieldKit } from 'containers/FormBuilder'
import { FormikValues } from 'formik'
import AssetSubtype from 'state/enums/AssetSubtype'
import AssetType from 'state/enums/AssetType'

interface QueryProps {
    assetSubtype?: AssetSubtype
    boatType?: string
    condition: string
    fieldName: string
    formik: FieldKit<FormikValues>
    label?: string
    prefilled?: boolean
    selectedYear: number | string
    hullCaptive?: string
}

const defaultProps = {
    assetSubType: null,
    boatType: '',
    hullCaptive: undefined,
}

export default function YearDropdown({
    formik,
    fieldName,
    assetSubtype,
    selectedYear,
    condition,
    boatType,
    label,
    prefilled,
    hullCaptive,
}: Readonly<QueryProps>) {
    const [response, updateResponse] = useState([] as Year[])

    const dataSource =
        condition === 'N' ? ['LOS_ADMIN', 'LOS'] : ['LOS_ADMIN', 'NADA']

    function getYearsForMarine(abortController: AbortController) {
        const getYearsOptions = {
            condition: condition === 'N' ? 'new' : 'used',
            dataSource,
            boatType,
            assetType: AssetType.MARINE,
            assetSubType: assetSubtype,
            captive:
                assetSubtype === AssetSubtype.MARINE_HULL
                    ? hullCaptive
                    : undefined,
        } as GetYearsOptions

        getYears(getYearsOptions, abortController)
            .then((yearsOptions: Year[]) => {
                updateResponse(yearsOptions)

                if (!yearsOptions.some((e) => e.id === selectedYear)) {
                    formik.setFieldValue(fieldName, '')
                }
            })
            .catch(() => {})
    }

    useEffect(() => {
        const abortController = new AbortController()

        if (condition) {
            getYearsForMarine(abortController)
        }

        return () => abortController.abort()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [condition, boatType])

    if (response.length < 1) {
        return (
            <FormikDropdown
                name={fieldName}
                label={label ?? 'Year'}
                placeholder="Select"
                disabled
                prefilled={prefilled}
            >
                {{ name: '', value: '' }}
                {{ name: '', value: '' }}
            </FormikDropdown>
        )
    }

    return (
        <FormikDropdown
            name={fieldName}
            label={label ?? 'Year'}
            placeholder="Select"
            disabled={response.length === 0}
            error={selectedYear === null || selectedYear === 0}
            prefilled={prefilled}
        >
            {response.map((child: Year) => {
                const newBorn: FormikDropdownChild = {
                    name: child.id.toString(),
                    value: child.id.toString(),
                }

                return newBorn
            })}
        </FormikDropdown>
    )
}

YearDropdown.defaultProps = defaultProps
